import { render } from "./MemberTile.vue?vue&type=template&id=453585ef"
import script from "./MemberTile.vue?vue&type=script&lang=js"
export * from "./MemberTile.vue?vue&type=script&lang=js"

import "./MemberTile.vue?vue&type=style&index=0&id=453585ef&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__